import {
  activeSalesDisplaySlides,
  type SalesDisplaySlide,
} from "@/lib/sales-display-slides";

export type SalesDisplayLoopSlide =
  | { id: string; kind: "team-goal"; durationSeconds: number }
  | { id: string; kind: "sales-pulse"; durationSeconds: number }
  | { id: string; kind: "hall-of-fame-timepris"; durationSeconds: number }
  | { id: string; kind: "hall-of-fame-geek"; durationSeconds: number }
  | { id: string; kind: "hall-of-fame-sales-unit-rate"; durationSeconds: number }
  | { id: string; kind: "sales-unit"; durationSeconds: number; unitId: string }
  | { id: string; kind: "message" | "image" | "video"; durationSeconds: number; slide: SalesDisplaySlide };

export function defaultSalesDisplayLoop(
  unitIds: string[],
  durationSeconds = 15,
): SalesDisplayLoopSlide[] {
  return [
    { id: "team-goal", kind: "team-goal", durationSeconds },
    { id: "sales-pulse", kind: "sales-pulse", durationSeconds },
    ...unitIds.map((unitId) => ({
      id: `sales-unit-${unitId}`,
      kind: "sales-unit" as const,
      unitId,
      durationSeconds,
    })),
    { id: "hall-of-fame-timepris", kind: "hall-of-fame-timepris", durationSeconds },
    { id: "hall-of-fame-geek", kind: "hall-of-fame-geek", durationSeconds },
    { id: "hall-of-fame-sales-unit-rate", kind: "hall-of-fame-sales-unit-rate", durationSeconds },
  ];
}

export function configuredSalesDisplayLoop(
  configured: SalesDisplaySlide[],
  unitIds: string[],
): SalesDisplayLoopSlide[] {
  const result: SalesDisplayLoopSlide[] = [];
  for (const slide of activeSalesDisplaySlides(configured)) {
    if (slide.kind !== "widget") {
      result.push({
        id: slide.id,
        kind: slide.kind,
        durationSeconds: slide.durationSeconds,
        slide,
      });
      continue;
    }
    if (slide.widgetKey === "kpi") {
      result.push({ id: `${slide.id}-kpi`, kind: "team-goal", durationSeconds: slide.durationSeconds });
    } else if (slide.widgetKey === "leaderboard") {
      result.push({ id: `${slide.id}-pulse`, kind: "sales-pulse", durationSeconds: slide.durationSeconds });
      result.push(...unitIds.map((unitId) => ({
        id: `${slide.id}-unit-${unitId}`,
        kind: "sales-unit" as const,
        unitId,
        durationSeconds: slide.durationSeconds,
      })));
    } else if (slide.widgetKey === "hall_of_fame") {
      result.push(
        { id: `${slide.id}-hall-timepris`, kind: "hall-of-fame-timepris", durationSeconds: slide.durationSeconds },
        { id: `${slide.id}-hall-geek`, kind: "hall-of-fame-geek", durationSeconds: slide.durationSeconds },
        { id: `${slide.id}-hall-unit-rate`, kind: "hall-of-fame-sales-unit-rate", durationSeconds: slide.durationSeconds },
      );
    }
    // Pipeline ble eksplisitt tatt ut av display-scope. En eventuell legacy-rad
    // ignoreres; migrasjonen fjerner den seedede standardraden.
  }
  return result.length > 0 ? result : defaultSalesDisplayLoop(unitIds);
}
